import React from 'react'
import { NoSsr } from '@material-ui/core'
import { string, func, shape, oneOfType, number, bool } from 'prop-types'
import TextField from './Input.style'

export default function Input({
  label,
  name,
  reference,
  errorMessage,
  defaultValue,
  disabled,
  onBlur,
  onFocus,
  onChange,
  control,
  inputLabelProps,
  value,
}) {
  return (
    <NoSsr>
      <TextField
        id={name}
        InputLabelProps={inputLabelProps}
        label={label}
        name={name}
        inputRef={reference}
        helperText={errorMessage}
        variant="outlined"
        defaultValue={defaultValue}
        value={value}
        control={control}
        disabled={disabled}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
      />
    </NoSsr>
  )
}

Input.propTypes = {
  label: string,
  name: string.isRequired,
  errorMessage: string,
  control: shape({}).isRequired,
  reference: func.isRequired,
  value: shape({}).isRequired,
  defaultValue: oneOfType([string, number, bool]),
  disabled: bool,
  onBlur: func,
  onFocus: func,
  onChange: func,
  inputLabelProps: shape({
    shrink: bool,
  }),
}

Input.defaultProps = {
  label: '',
  inputLabelProps: {},
  errorMessage: '',
  defaultValue: '',
  disabled: false,
  onBlur: () => {},
  onFocus: () => {},
  onChange: () => {},
}
